import { useQuery } from "@tanstack/react-query";
import {
  filterFidelizationCandidates,
  getFidelizationCandidates,
  FidelizationCandidatesFilters,
  PageResponse,
  FidelizationCandidateResponse,
} from "@/shared/actions/campanas/fidelizacion.actions";

type DataSourceType = "" | "CSV" | "INTERNAL_SEARCH";

export const useFidelizationCandidates = (
  page: number,
  size: number,
  filters?: FidelizationCandidatesFilters,
  dataSource?: DataSourceType
) => {
  const hasFilters = !!(
    filters?.zone ||
    filters?.plan ||
    filters?.fromDate ||
    filters?.toDate
  );

  const query = useQuery({
    queryKey: ["fidelization-candidates", page, size, filters, dataSource],
    queryFn: async () => {
      if (hasFilters) {
        return await filterFidelizationCandidates(
          page,
          size,
          filters ?? {},
          dataSource
        );
      }

      return await getFidelizationCandidates(page, size, dataSource);
    },
    enabled: !!dataSource,
    refetchOnWindowFocus: false,
  });

  return {
    data: (query.data?.data ?? query.data ?? null) as
      | PageResponse<FidelizationCandidateResponse>
      | null,
    loading: query.isLoading,
    error: query.isError,
    refetch: query.refetch,
  };
};